export const PAYLOAD_KEY = '__telemetryEvent__' as const
